import { defineStore } from "pinia";
import apiClient from "@/plugins/axios";

export const useNewsStore = defineStore("news", {
  state: () => ({
    news: [],
    totalPages: 1,
    currentPage: 1,
    totalResults: 0,
    loading: false,
    error: "",
  }),

  actions: {
    /**
     * Obtener listado de noticias publicadas
     */
    async fetchNews(params = {}) {
      this.loading = true;
      this.error = "";

      try {
        const response = await apiClient.get("/public/news", {
          params: {
            page: params.page ?? this.currentPage,
          },
        });

        this.news = response.data.data;
        this.currentPage = Number(response.data.current_page);
        this.totalPages = Number(response.data.last_page);
        this.totalResults = Number(response.data.total);
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          this.error =
            "No se pudo conectar al servidor. Por favor, intenta nuevamente más tarde.";
        } else {
          this.error =
            error.response?.data?.message ||
            "Error al cargar las noticias. Intente de nuevo más tarde.";
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Cambiar de página
     */
    async changePage(page) {
      this.currentPage = page;
      await this.fetchNews();
    },

    /**
     * Resetear
     */
    resetStore() {
      this.news = [];
      this.totalPages = 1;
      this.currentPage = 1;
      this.totalResults = 0;
      this.error = "";
    },
  },
});
